import Link from 'next/link'
function Footer() {
    return (
        <footer className="footerContainer">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 postBody">
                <div className="col-span-3 lg:col-span-2 text-center border-b-2 border-white pt-10 pb-4 flex flex-wrap pr-6">
                    <div className="flex-none w-20 h-20 footerImg sm:mb-5">
                        <img src="/img/logo.jpeg" className="rounded-md" />
                    </div>
                    <p className="px-8 text-right readmore w-full">
                        کاج استور یک فروشگاه اینترنتی است که فعالیت خود را از سال ۱۳۹۳ در اینستاگرام با فروش آنلاین نوشت
                        افزار و انواع لوازم تحریر فانتزی آغاز کرد و اولین ایده پرداز فروش آنلاین لوازم تحریر فانتزی در
                        کل کشور بود. کاج استور با افزایش طیف محصولات خود به انواع وسایل فانتزی دیگر و همچنین لطف و
                        استقبال مشتریان عزیزش کم کم گسترش یافت. همواره تمام پرسنل تیم کاج استور نهایت تلاش خود را به عمل
                        می آورند تا با ارائه ی باکیفیت ترین محصولات، تجربه ای خوشایند از خرید اینترنتی را برای مخاطبان
                        خود به ارمغان بیاورد.
                    </p>
                    <div className="loadMore">
                        [ <a href="/about">بیشتر</a> ]
                    </div>
                </div>
                <div className="col-span-3 lg:col-span-1 row-span-3 text-center lg:border-r-2 lg:border-b-0 border-b-2  border-white lg:pb-0 lg:pt-10">
                    
                    <div className="p-1 text-center lg:text-center w-auto block text-xl justify-self-center">
                        
                        پیگیری از طریق واتسپ
                        
                    </div>
                    <a href="https://wa.me/989125728853"><img className="w-32 mb-5 lg:w-1/3 mt-5 mx-auto" src="/img/icons/png/whats.png" alt="" /></a>

                    <Link href="/contact">
                        <a className="hidden  text-center lg:block border-solid border-2 border-pink-300 text-pink-300 font-semibold py-3 px-20  rounded mt-10 mx-5 hover:text-white  hover:bg-pink-300 hover:border-transparent ">
                            <span className="text-center">با ما تماس بگیرید</span>
                        </a>
                    </Link>
                    <ul className="lg:mt-10 list-none flex align-center p-2 flex-grow justify-center  ">
                        <li>
                            <a
                                href="https://www.instagram.com/kaajstore/"
                                target="_blank"
                                rel="noreferrer"
                                className="p-2 border border-gray-400 bg-gray-100 rounded-md flex justify-center ml-2 w-9 h-9"
                            >
                                <img src="/img/icons/png/icons8-instagram-100.png" className="opacity-50" alt="" />
                            </a>
                        </li>
                        <li>
                            <a className="p-2 border border-gray-400 bg-gray-100 rounded-md flex justify-center ml-2 w-9 h-9">
                                <img src="/img/icons/png/icons8-whatsapp-100.png" className="opacity-50" alt="" />
                            </a>
                        </li>
                        <li>
                            <a className="p-2 border border-gray-400 bg-gray-100 rounded-md flex justify-center ml-2 w-9 h-9">
                                <img src="/img/icons/png/telegram.png" className="opacity-50" alt="" />
                            </a>
                        </li>
                    </ul>
                    <div className="flex justify-center">
                        <Link href="https://trustseal.enamad.ir/?id=202215&amp;Code=G0vQ99xnSbr1FplCsLw6">
                            <a referrerPolicy="origin" target="_blank">
                                <img
                                    loading="lazy"
                                    referrerPolicy="origin"
                                    src="https://Trustseal.eNamad.ir/logo.aspx?id=202215&amp;Code=G0vQ99xnSbr1FplCsLw6"
                                    alt=""
                                    id="G0vQ99xnSbr1FplCsLw6"
                                    className="w-20 m-5"
                                />
                            </a>
                        </Link>
                    </div>
                </div>
                <div className="col-span-3 lg:col-span-2 row-span-2 text-center p-4 lg:pb-4 pb-20 mb-20 lg:mb-0">
                    <div className="grid grid-cols-3 gap-4">
                        <dl className="text-right listFooter">
                            <dt className="font-bold text-lg mb-2 xs:text-center">دسترسی های سایت</dt>
                            <dd>
                                <Link href="/">
                                    <a>خانه</a>
                                </Link>
                            </dd>
                            <dd>
                                <Link href="/products/list">
                                    <a>محصولات</a>
                                </Link>
                            </dd>
                        </dl>
                        <dl className="text-right listFooter">
                            <dt className="font-bold text-lg mb-2 xs:text-center">راهنما و اطلاعات</dt>
                            <dd>
                                <Link href="/faq">
                                    <a>سوالات متداول</a>
                                </Link>
                            </dd>
                            <dd>
                                <Link href="/terms">
                                    <a>قوانین</a>
                                </Link>
                            </dd>
                        </dl>
                        <dl className="text-right listFooter">
                            <dt className="font-bold text-lg mb-2 xs:text-center">خدمات مشتریان</dt>
                            <dd>
                                <Link href="/cart">
                                    <a>سبد خرید</a>
                                </Link>
                            </dd>
                            <dd>
                                <Link href="/profile">
                                    <a>پروفایل کاربری </a>
                                </Link>
                            </dd>
                        </dl>
                    </div>
                    <div className="text-center mt-10">
                        قدرت گرفته از{' '}
                        <a className="text-pink-600" href="https://boomcloud.ir" target="_blank" rel="noreferrer">
                            پلتفرم فروشگاهی بوم
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export { Footer }
